module.exports = __webpack_public_path__ + "static/img/inclusive-gateway.aef68fe7.svg";